import React from 'react';
import { Link } from 'react-router-dom';
import $ from 'jquery';
import ImageWebp from 'react-image-webp';
import Constant from "../../utils/Constant";
import axios from 'axios';
import LocalStorageService from "../../utils/LocalStorageService";
import Header from "../common/Header";
import Cookies from 'js-cookie';
import { decrypt, key } from '../../utils/encryptiondecryption';
class LiveChannels extends React.Component {
  constructor() {
    super();
    // code chunk for getting encrypted data from cookies and using inside 
    const ciphertext = Cookies.get('YUTETOLPBG-ASY1BSBD#!ASDNMlPOS--_AWQQWyADIURYBDSF092B34BSDSEWEWFELPOWD');
    const decryptedText = decrypt(ciphertext, key);
    this.state = {
      auth: {
        device_id: decryptedText.length > 1 ? (decryptedText[0][1] === 'null' ? null : decryptedText[0][1]) : null,
        phone_details: decryptedText.length > 1 ? (decryptedText[1][1] === 'null' ? null : decryptedText[1][1]) : null,
        user_id: decryptedText.length > 1 ? (decryptedText[2][1] === 'null' ? null : decryptedText[2][1]) : null,
        mobile: decryptedText.length > 1 ? (decryptedText[3][1] === 'null' ? null : decryptedText[3][1]) : null,
        package_id: decryptedText.length > 1 ? (decryptedText[4][1] === 'null' ? null : decryptedText[4][1]) : null,
        subscription_expiry_datetime: decryptedText.length > 1 ? (decryptedText[5][1] === 'null' ? null : decryptedText[5][1]) : null,
      },}}


  componentDidMount() {
    window.imgNotFound();
  }

  addToFavourite = (heart_id, channelId) => {
    
    if (!localStorage.getItem('user_id')) {
      new Header().openLoginModal();
      return;
    }
    if ($("#" + heart_id).hasClass('active')) {

      $("#heart_8632" + channelId).removeClass('active')
      $("#" + heart_id).removeClass('active');
      let classRef = this;
      axios({
        method: 'POST',
        url: Constant.url + "remove-favourite",
        headers: { 'Authorization': "bearer " + localStorage.getItem("access_token") },
        data: { id: channelId, user_id: localStorage.getItem('user_id'),type: "channel" },
      }).then(function (result) {
        let response = {};
        response["data"] = JSON.parse(LocalStorageService.decryptAes(result.data.eData));
        
        if (response.data.code === 200 && response.data.status === true) {


        }
      })
    } else {
      $("#" + heart_id).addClass('active');
      $("#heart_8632" + channelId).addClass('active')
      let classRef = this;
      let params = JSON.stringify({channel_id: channelId, user_id: localStorage.getItem('user_id')});
      axios({
        method: 'POST',
        url: Constant.url + "add-user-favourite-channels-2",
        headers: { 'Authorization': "bearer " + localStorage.getItem("access_token") },
        // data: { dataparams: LocalStorageService.encryptAes(params)},
        data: { channel_id: channelId, user_id: localStorage.getItem("user_id") },
      }).then(function (result) {
        let response = {};
        response["data"] = JSON.parse(LocalStorageService.decryptAes(result.data.eData));
        
        if (response.data.code === 200 && response.data.status === true) {

        }
      })
    }
  }

  handleChannelList = () => {
    let channels = "";
    channels = this.props.data.map((channel, index) => (
      <li key={index} className="uk-width-1-6@l uk-width-1-5@m uk-width-1-3@s uk-width-1-2">
        <div className="live_style live_style_full RelatedFilterBox">
        {
            this.state.auth.user_id ? 
            <Link className="fav_sld_img" to={(channel.channel_status === 'live' ? '/' + channel.channel_slug : "/channel/" + channel.channel_slug)}>
              <ImageWebp className="img_log" webp={channel.channel_logo} src={channel.channel_logo_jpg} alt={channel.channel_name} />
              <ImageWebp webp={channel.channel_live_image} src={channel.channel_live_image_jpg} alt={channel.channel_name} />
              <h4>{channel.channel_name}</h4>
              <span className="views_txt">{channel.channel_views}</span>
            </Link> :
            <Link className="fav_sld_img" 
              // to={"/register"}
              onClick={()=>{ window.location.href = "http://he.mjunoon.tv:8080/register" }}
            >
              <ImageWebp className="img_log" webp={channel.channel_logo} src={channel.channel_logo_jpg} alt={channel.channel_name} />
              <ImageWebp webp={channel.channel_live_image} src={channel.channel_live_image_jpg} alt={channel.channel_name} />
              <h4>{channel.channel_name}</h4>
              <span className="views_txt">{channel.channel_views}</span>
            </Link>
          }
          {/* {(channel.is_fav) ?
            <span className="relatedHeart active" id={"heart_8632" + channel.channel_id} uk-icon="icon: heart" onClick={(e) => this.addToFavourite("heart_8632" + channel.channel_id, channel.channel_id, e)}></span>
            : <span className="relatedHeart" uk-icon="icon: heart" id={"heart_8632" + channel.channel_id} onClick={(e) => this.addToFavourite("heart_8632" + channel.channel_id, channel.channel_id, e)}></span>
          } */}
          
        </div></li>
    ));
    return channels;
  };

  render() {
    return (
      <div>
        <section id={(this.props.typeid) ? "type" + this.props.typeid : ''} className={(this.props.ad_class === 'a') ? "pad_left pad_tb pad_right fav_slider" : "pad_left pad_t pad_right fav_slider"}>
          <div className="headng_box">
            <h2 className="h2forhome"><strong>{this.props.name}</strong></h2>
          </div>
          <ul className="uk-height-match uk-grid-small" uk-grid="">
            {this.handleChannelList()}
          </ul>
        </section>
      </div>
    );
  }
}

export default LiveChannels;